@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackSearchCases {
  .title {
    font-size: 28px;
    margin-bottom: 20px;

    @include texts.font("bold");
  }

  .cases {
    display: flex;
    gap: 25px;

    .case {
      padding: 40px 25px;
      display: flex;
      flex-direction: column;
      position: relative;
      gap: 25px;
      width: 50%;
      border-radius: 22px;
      border: 1px solid rgba(255, 255, 255, 0.18);
      background: linear-gradient(180deg, rgba(46, 204, 113, 0.00) 0%, rgba(46, 204, 113, 0.06) 100%);

      .name {
        font-size: 18px;
        text-align: center;
        position: relative;
        z-index: 1;

        @include texts.font("semi-bold");
      }

      .value {
        text-align: center;
        font-size: 40px;
        color: var(--web-green);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 30px;

        @include texts.font("bold");

        .arrow {
          filter: var(--icon-web-green);
          width: 20px;
          height: 20px;

          @include icons.ico("black-right-arrow");
        }
      }
    }
  }

  @media (max-width: 750px) {
    .title {
      font-size: 23px !important;
    }

    .cases {
      flex-direction: column;

      .case {
        width: calc(100% - 50px);

        .name {
          font-size: 16px;
        }
      }
    }
  }
}